var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.temFerramentas
    ? _c(
        "ComposerInlineSelect",
        _vm._g(
          {
            ref: "select",
            staticClass: "composer-ferramentas",
            attrs: {
              direction: "auto",
              "largura-total": "",
              "active-color": "var(--primary)",
              "icon-color": "var(--neutral-700)",
              label: "Ferramentas",
              icon: "plus-line",
              "so-icone": "",
              "manter-foco": "",
              "tamanho-do-icone": _vm.TAMANHO_DO_MAIS,
              options: _vm.opcoes,
              rodape: _vm.rodape,
              disabled: _vm.disabled
            }
          },
          _vm.$listeners
        )
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }